import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'CHAPTER_CONTENTS_GET',
  GET_SUCCESS: 'CHAPTER_CONTENTS_GET_SUCCESS',
  GET_FAILURE: 'CHAPTER_CONTENTS_GET_FAILURE',
  INVALIDATE_ITEM: 'CHAPTER_CONTENTS_INVALIDATE_ITEM',
  GET_ALL: 'CHAPTER_CONTENTS_GET_ALL',
  GET_ALL_SUCCESS: 'CHAPTER_CONTENTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CHAPTER_CONTENTS_GET_ALL_FAILURE',
};

export const get = actions.get(
  chapterContentId => `${BASE_URL}/curriculum/chapter-contents/${chapterContentId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/curriculum/chapter-contents/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
